import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';

// ---- P1-B gateway refunds ----
export type RefundProvider = 'BKASH' | 'SSLCOMMERZ';
export type RefundStatus = 'REQUESTED' | 'PROCESSING' | 'COMPLETED' | 'FAILED' | 'NEEDS_RECONCILIATION' | 'REVERSED';

export interface RefundAttempt {
  attemptId: string; provider: RefundProvider; mode: 'SANDBOX' | 'LIVE'; paidAt?: string | null;
  amount: number; refundable: number; eligible: boolean; reason?: string | null;
}
export interface RefundEligibility { eligible: boolean; reason?: string | null; cap: number; attempts: RefundAttempt[]; }

export interface GatewayRefund {
  id: string; creditNoteId: string; attemptId: string; provider: RefundProvider; mode: 'SANDBOX' | 'LIVE';
  amount: number; reason: string; status: RefundStatus; providerRefundId?: string | null;
  creditNoteRefundId?: string | null; failureReason?: string | null; createdAt: string;
}
export interface GatewayRefundSetting { provider: RefundProvider; refundsEnabled: boolean; }

export const GatewayRefundService = {
  eligibility: async (noteId: string): Promise<RefundEligibility> =>
    (await axios.get(ENDPOINTS.GATEWAY_REFUND.ELIGIBILITY(noteId))).data,
  list: async (noteId: string): Promise<GatewayRefund[]> =>
    (await axios.get(ENDPOINTS.GATEWAY_REFUND.BY_NOTE(noteId))).data,
  request: async (noteId: string, body: { attemptId: string; amount: number; reason: string }): Promise<GatewayRefund> =>
    (await axios.post(ENDPOINTS.GATEWAY_REFUND.BY_NOTE(noteId), body)).data,
  recheck: async (id: string): Promise<GatewayRefund> => (await axios.post(ENDPOINTS.GATEWAY_REFUND.RECHECK(id))).data,
  resolve: async (id: string, body: { note: string; creditNoteRefundId?: string }): Promise<GatewayRefund> =>
    (await axios.post(ENDPOINTS.GATEWAY_REFUND.RESOLVE(id), body)).data,
  book: async (id: string): Promise<GatewayRefund> => (await axios.post(ENDPOINTS.GATEWAY_REFUND.BOOK(id))).data,
  bookManually: async (id: string, body: { refundDate: string; paymentAccountId: string; reference?: string; note: string }): Promise<GatewayRefund> =>
    (await axios.post(ENDPOINTS.GATEWAY_REFUND.BOOK_MANUAL(id), body)).data,
  settings: async (institutionId: string): Promise<GatewayRefundSetting[]> =>
    (await axios.get(ENDPOINTS.GATEWAY_REFUND.SETTINGS(institutionId))).data,
  saveSetting: async (institutionId: string, body: GatewayRefundSetting): Promise<GatewayRefundSetting[]> =>
    (await axios.put(ENDPOINTS.GATEWAY_REFUND.SETTINGS(institutionId), body)).data,
};
// ---- end P1-B ----
